import { render } from "./BrandFooter.vue?vue&type=template&id=195b8f68"
import script from "./BrandFooter.vue?vue&type=script&lang=js"
export * from "./BrandFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__